var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 52,
    viewBox: "0 0 69 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5741 49.223C40.3427 47.6993 47.585 46.4385 47.6682 46.4211L47.8194 46.3896L39.541 36.7036C34.9879 31.3763 31.2627 26.9969 31.2627 26.9717C31.2627 26.9239 39.8108 3.76874 39.8589 3.68636C39.8749 3.65882 45.6922 13.5381 53.9602 27.6343C61.701 40.8315 68.0828 51.7126 68.1422 51.8146L68.25 52L41.9407 51.9967L15.6313 51.9933L31.5741 49.223ZM0 46.2692C0 46.2556 3.90073 39.5949 8.66828 31.4676L17.3366 16.6907L27.4384 8.35168C32.9945 3.76521 37.5553 0.00704239 37.5736 0.000188396C37.5918 -0.00666425 37.5188 0.174285 37.4111 0.4023C37.3035 0.630316 32.3674 11.0449 26.4419 23.5458L15.6684 46.2747L7.83419 46.2844C3.52539 46.2897 0 46.2829 0 46.2692Z",
    fill: "#0089D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.d3122c584f56fd160075fd71e1049d7b.svg";
export { ForwardRef as ReactComponent };